import { PostHog } from 'posthog-node'
import type { RequestContext } from '../types'

interface PostHogMock {
  capture: (event: unknown) => void
  shutdown: () => Promise<void>
  captureException: (error: Error) => void
}

const isNode = typeof process !== 'undefined' && process.versions?.node

let posthog: PostHog | PostHogMock

if (isNode && process.env.POSTHOG_API_KEY) {
  posthog = new PostHog(process.env.POSTHOG_API_KEY, {
    host: 'https://us.i.posthog.com',
    enableExceptionAutocapture: true,
    flushAt: 1
  })
} else {
  posthog = {
    capture: () => {},
    captureException: () => {},
    shutdown: async () => {}
  }
}

export const logError = (component: string, message: string, error: Error) => {
  posthog.captureException(error)
  console.error(`[${component}]: ${message}`, {
    message: error?.message,
    stack: error?.stack,
    name: error?.name
  })
}

export const track = (
  context: RequestContext,
  event: string,
  properties: {
    [key: string]: string | number | boolean | null | undefined
  } = {}
) => {
  // Convert any array property values to comma-separated strings
  const safeProperties: Record<
    string,
    string | number | boolean | null | undefined
  > = {}
  for (const [k, v] of Object.entries(properties)) {
    if (Array.isArray(v)) {
      safeProperties[k] = v.join(',')
    } else {
      safeProperties[k] = v
    }
  }
  posthog.capture({
    distinctId: context.accountId || context.cloudId,
    event,
    properties: {
      cloudId: context.cloudId,
      moduleKey: context.moduleKey,
      ...safeProperties
    }
  })
}

if (isNode) {
  process.on('beforeExit', async () => {
    await posthog.shutdown()
  })
}
